import { Box, Button, Grid, styled, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { NearMe } from "@mui/icons-material";
import { Link } from "react-router-dom";


const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.5rem',
  [theme.breakpoints.up('md')]: {
    fontSize: '2.2rem',
  },
}));

const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    fontSize: '1.3rem',
  },
}));

const PointGrid = styled(Grid)(({ theme }) => ({
  width: '90%',
  fontSize: '1rem',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    width: '47%',
    fontSize: '1.3rem',
  },
}));

const StyledIcon = styled(NearMe)(({ theme }) => ({
  fontSize: '1rem',
  [theme.breakpoints.up('md')]: {
    fontSize: '1.3rem',
  },
}));

const PointsTypography = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  [theme.breakpoints.up('md')]: {
    fontSize: '1.3rem',
  },
}));

const StyledGridContainer = styled(Grid)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(4),
  backgroundColor: '#242424',
  color: '#ffffff',
}));


const Slide = ({ title, subTitle, points, buttonText, targetSection }) => {

  return(
    <>
      <Title>{title}</Title>
      <Subtitle>{subTitle}</Subtitle>

      <StyledGridContainer container spacing={1} columnSpacing={4} justifyContent="left">
        {
          points.map((point, index) => ((
            <PointGrid item key={index}>
              <StyledIcon />
              <PointsTypography>{point}</PointsTypography>
            </PointGrid>
          )))
        }
      </StyledGridContainer>

      <Link to={`/about#${targetSection}`} ><StyledButton variant="contained">{buttonText}</StyledButton></Link>
    </>
  )
}


function AboutSlick() {

  const slidesData = [
    {
      title: "Who We Are",
      subTitle: "Where Data Meets Strategy - That's DataPi",
      points: [
        "Data-Driven Research Experts",
        "Cross-Industry Specialists",
        "Agile & Actionable Insights",
        "Trusted by Decision-Makers"
      ],
      buttonText: "Discover Us",
      targetSection: "Introduction-section"
    },
    {
      title: "What We Offer",
      subTitle: "From Insights to Impact - Intelligence That Works",
      points: [
        "Competitive Intelligence & SWOTs",
        "Market Research Reports",
        "Sector & Innovation Intelligence",
        "Trends & Competitive Tracking"
      ],
      buttonText: "Explore Our Services",
      targetSection: "WhatWeOffer-section"
    },
    {
      title: "Why Us",
      subTitle: "Customized Research. Smarter Decisions. Real Results",
      points: [
        "Custom & Scalable Research",
        "Executive-Level Insights",
        "Fast, Reliable Delivery",
        "End-to-End Intelligence"
      ],
      buttonText: "Our Advantage",
      targetSection: "ResearchMethodology-section"
    }
  ];

  return (
    <Box  sx={{ color: '#242424' }} >
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={10}
        slidesPerView={1}
        autoplay={{ delay: 8000 }}
        loop={true}
        speed={1000}
      >
        {
          slidesData.map((slide, index) => ((
            <SwiperSlide key={index} >
              <Slide {...slide} />
            </SwiperSlide>
          )))
        }
      </Swiper>
    </Box>
  );
}

export default AboutSlick;
